// extracted by mini-css-extract-plugin
module.exports = {"clip":"ClipAnimation_clip__SFtbc","reverse":"ClipAnimation_reverse__4Gs7V","reveal":"ClipAnimation_reveal__fdWAk","long":"ClipAnimation_long__c2weT"};